module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image21a.3be85a60.webp";